/**
 * @file
 * Kit window: a portaled popover with region slots.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components, popover } = berTags;
  const { Container, events } = window.BerUi;
  const { LOADING, LOADED } = events;
  const ui = Drupal.berUI;
  const { container } = ui.compose;

  // The main window: a portaled popover whose shell is the root view -
  // header, body, footer and crumb slots plus open/close/place.
  // loader: false suspends the window's own fallback spinner - use it when
  // the views inside carry their own loaders (else both would show).
  ui.window = ({
    trigger,
    home,
    label,
    caret = true,
    potential,
    loader = true,
    onOpen,
    onClose,
  } = {}) => {
    const shell = components.list({ label });
    if (potential !== undefined) {
      shell.el.dataset.berPotential = String(potential);
    }
    const wired = popover.wire({
      add: trigger,
      pop: shell.el,
      home,
      opts: { caret },
      onOpen,
      onClose,
    });
    const api = container(
      Object.assign(new Container(shell.el), {
        header: shell.header,
        body: shell.body,
        footer: shell.footer,
        crumb: shell.crumb,
        open: wired.open,
        close: wired.close,
        place: () => popover.place(trigger, shell.el, { caret }),
      }),
      { header: shell.header, body: shell.body, footer: shell.footer },
    );
    // The window body carries a core loader of its own.
    if (loader) {
      api.spinner = components.spinner();
      shell.body.appendChild(api.spinner.el);
      let pending = 0;
      shell.el.addEventListener(LOADING, () => {
        pending++;
        api.spinner.show(150);
      });
      shell.el.addEventListener(LOADED, () => {
        pending = Math.max(0, pending - 1);
        if (!pending) {
          api.spinner.hide();
        }
      });
    }
    ui.emit('window', { component: api });
    return api;
  };

  ui.register('window', ui.window);
})(Drupal);
